export const homeIconStyle = {
    mr: '3px',
    mb: '1px',
    '& > svg': {
        height: '11px',
        width: '11px',
    },
}
export const tvIconStyle = {
    mr: '2px',
    mt: '0.5px',
    '& > svg': {
        height: '11.7px',
        width: '11.7px',
    },
}
export const epgIconStyle = {
    mr: '2px',
    mt: '5.5px',
    '& > svg': {
        height: '17px',
        width: '17px',
    },
}
export const vodIconStyle = {
    mr: '2px',
    mt: '2px',
    '& > svg': {
        height: '13px',
        width: '13px',
    },
}
